import { Alert as ReactAlert } from '@a-ui/react';
import React from 'react';
import Typography from '../../components/Typography';
import useConfig from '../../hooks/config.hooks';
import { translateHTML } from '../../i18n';

interface ACardEmptyAlertProps {
  card?: Api.UserACard;
}

const ACardEmptyAlert: React.FC<ACardEmptyAlertProps> = ({ card }) => {
  const { ACARD_INFO_URL } = useConfig();

  if (!card || card.pointsBalance >= 1 || card.cheques?.length) {
    return <></>;
  }

  return (
    <div className="u-margin-bottom">
      <ReactAlert>
        <Typography>
          {translateHTML('acard.pointsCheques.points.empty', {
            a: (...chunks: any[]) => (
              <a href={ACARD_INFO_URL} target="_blank">
                {chunks}
              </a>
            ),
          })}
        </Typography>
      </ReactAlert>
    </div>
  );
};

export default ACardEmptyAlert;
